module.exports = "/images/escape room.svg?c632a4ccc7602b78b4ee610502574c23";